import script from "./KCW.vue?vue&type=script&lang=js"
export * from "./KCW.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__